import Vue from 'vue';
import Vuex from 'vuex'

Vue.use(Vuex)

import app from './modules/app'
import permission from './modules/permission'
import user from './modules/user'
import tagsView from './modules/tagsView'
import getters from './getters'
import singleCard from './modules/singleCard'
import dashboard from './modules/dashboard'

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    user,
    tagsView,
    singleCard,
    dashboard
  },
  getters,
  strict: false
})

export default store
